module.exports = __webpack_public_path__ + "img/screen_first.4b7f16b0.png";